import React, { useContext, useEffect, useState } from "react";
import { Box, Heading, SimpleGrid, Card, CardHeader, CardBody, Table, Thead, Tbody, Tr, Th, Td, Spinner } from "@chakra-ui/react";
import { Navigate } from "react-router-dom";
import AuthContext from "../../../contexts/Auth";
import client from "../../../helpers/Client";

export default function AdminUnitsProjects() {
  const auth = useContext(AuthContext);
  const isSuperUser = auth.data?.user?.is_superuser;
  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([]);
  const [units, setUnits] = useState([]);

  // Hooks must be called unconditionally; avoid early return before effects

  const fetchAll = async () => {
    setLoading(true);
    try {
      const [pRes, uRes] = await Promise.all([
        client.get("/projects/"),
        client.get("/units/"),
      ]);
      setProjects(pRes.data.results || pRes.data);
      setUnits(uRes.data.results || uRes.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isSuperUser) return;
    fetchAll();
  }, [isSuperUser]);

  if (!isSuperUser) {
    return <Navigate to="/ana-sayfa/" replace />;
  }

  return (
    <Box p={6}>
      <Heading size="md" mb={4}>Projeler ve Üniteler</Heading>
      {loading ? (
        <Spinner />
      ) : (
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
          <Card variant="outline">
            <CardHeader>Projeler</CardHeader>
            <CardBody>
              <Table size="sm">
                <Thead>
                  <Tr><Th>Ad</Th><Th>Şehir</Th><Th>İlçe</Th></Tr>
                </Thead>
                <Tbody>
                  {projects.map((p) => (
                    <Tr key={p.url || p.name}>
                      <Td>{p.name}</Td>
                      <Td>{p.city_info?.name || '-'}</Td>
                      <Td>{p.district_info?.name || '-'}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </CardBody>
          </Card>
          <Card variant="outline">
            <CardHeader>Üniteler</CardHeader>
            <CardBody>
              <Table size="sm">
                <Thead>
                  <Tr><Th>Ad</Th><Th>Proje</Th><Th>Durum</Th></Tr>
                </Thead>
                <Tbody>
                  {units.map((u) => (
                    <Tr key={u.url || u.name}>
                      <Td>{u.name}</Td>
                      <Td>{u.project_info?.name || '-'}</Td>
                      <Td>{u.is_active ? 'Aktif' : 'Pasif'}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </CardBody>
          </Card>
        </SimpleGrid>
      )}
    </Box>
  );
}